import config from '../config/app'
import axios from 'axios'
import Helper from '../helper/helper'
const VERSION = '/v2'

const userAPI = {
  hideCreditNotification (userId, type) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/credit-notification?user_id=' + userId + '&type=' + type).then((response) => {
        resolve(true)
      }, (error) => {
        reject(error)
      })
    })
  },
  broadcastNotification (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/broadcast-notification', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  impersonateLeave () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/impersonate/leave').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  impersonate (userId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/impersonate/' + userId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  setGiftCardMsg (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/user/set-giftcard-msg', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  checkEmailFree (email, exceptUserId = 0) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/check-email-free', {email: email, userId: exceptUserId}).then((response) => {
        resolve(response.data.free)
      }, (error) => {
        reject(error)
      })
    })
  },
  checkReferalInviteEmailFree (email, companyId, exceptUserId = 0) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/check-invite-email-free', {email: email, userId: exceptUserId, companyId: companyId}).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  checkEmailFree1 (email, companyId, exceptUserId = 0) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/check-email-free', {email: email, userId: exceptUserId, companyId: companyId}).then((response) => {
        resolve(response.data.free)
      }, (error) => {
        reject(error)
      })
    })
  },
  changeToAdmin () {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/switch-type', {type: 'admin'}).then((response) => {
        resolve(true)
      }, (error) => {
        reject(error)
      })
    })
  },
  changeToPartner () {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/switch-type', {type: 'partner'}).then((response) => {
        resolve(true)
      }, (error) => {
        reject(error)
      })
    })
  },
  changeToBusiness () {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/switch-type', {type: 'business'}).then((response) => {
        resolve(true)
      }, (error) => {
        reject(error)
      })
    })
  },
  switchAccount (isAdmin) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/switch-account', {isAdmin}).then((response) => {
        resolve(true)
      }, (error) => {
        reject(error)
      })
    })
  },

  getTeamUsers (companyId, userId, additional) {
    let query = {'company_id': companyId}
    if (userId) {
      query.not_id = userId
    }
    return this.get(query, additional)
  },
  /**
   * Base method for get users
   *
   * @param params
   * @param additional
   * @returns {Promise}
   */
  get (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/user?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  /**
   * Method for getting a partner user
   *
   * @param params
   * @param additional
   * @returns {Promise}
   */
  getPartner (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/user/partner?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },

  /**
   * Get Business users for a business
   * @param filters
   * @param additional
   * @returns {*|Promise}
   */
  searchBusinessUsers (filters, additional) {
    if (filters !== undefined) {
      filters.type = 'business'
      filters.status = 'active'
    } else {
      filters = {type: 'business'}
    }
    return this.get(filters, additional)
  },
  searchPartnerUsers (filters, additional) {
    if (filters !== undefined) {
      filters.type = 'partner'
    } else {
      filters = {type: 'partner'}
    }
    return this.get(filters, additional)
  },
  /**
   *
   * @param userId
   * @param additional
   * @returns {*|Promise}
   */
  getInviteUserCompany (userId, additional) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/inviteUserCompany?user_id=' + userId).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  /**
   *
   * @param userId
   * @param additional
   * @returns {*|Promise}
   */
  getUserById (userId, additional) {
    return new Promise((resolve, reject) => {
      this.get({id: userId}, additional).then((response) => {
        resolve(response.data[0])
      }, (error) => {
        reject(error)
      })
    })
  },
  downloadImpactCertificateold (companyId) {
    let url = config.server + '/user/impact-certifcate'
    let headers = new Headers()
    let token = localStorage.getItem('token')
    let authToken = token.indexOf('Bearer') > -1 ? token : 'Bearer ' + token
    headers.append('Authorization', authToken)
    let params = '?company_id=' + companyId
    return fetch(url + params, {headers}).then(response => response.blob())
  },
  downloadImpactCertificate (partnerlevel, companyName, logo = '') {
    let url = config.server + '/user/impact-certifcate'
    let headers = new Headers()
    let token = localStorage.getItem('token')
    let authToken = token.indexOf('Bearer') > -1 ? token : 'Bearer ' + token
    headers.append('Authorization', authToken)
    let params = ''
    params = '?partnerlevel=' + partnerlevel + '&company_name=' + companyName + '&logo=' + logo
    return fetch(url + params, {headers}).then(response => response.blob())
  },
  getUserSubscriptionDataById (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/user/subscription', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCompanyOwnerByCompanyId (companyId, type) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/companies-details', {companyId: companyId, type: type}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserGlobalImpacts (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/user-global-impacts', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  storeAppOnboardingDetails (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/user/save-apponboarding-data', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  referWorthyCause (data, user = null) {
    return new Promise((resolve, reject) => {
      let url = ''
      if (user) {
        url = '/user/refer-worthy-cause'
      } else {
        url = '/guest/user/refer-worthy-cause'
      }
      axios.post(config.server + VERSION + url, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  getUser (userId, additionalFields) {
    // console.log('userAPI.getUser is deprecated')
    return this.getUserById(userId, additionalFields)
  },
  getInvitedConnectionsList (additional, params) {
    params = typeof params === 'object' && params !== null ? params : {}
    let str = (additional !== null && additional !== undefined) ? 'additional=' + additional.join(',') + '&' : ''
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/invitedList?' + str + stringParams).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  // getInvitedConnections (additionalFields) {
  //   let str = (additionalFields !== null && additionalFields !== undefined) ? 'additional=' + additionalFields.join(',') + '&' : ''
  //   return new Promise((resolve, reject) => {
  //     axios.get(config.server + '/user/invited?' + str).then((response) => {
  //       resolve(response.data)
  //     }, (error) => {
  //       // reject({error: error.body.error, status: error.status})
  //       reject(error)
  //     })
  //   })
  // },
  getPartners (filters, additional) {
    // console.log('userAPI.getPartners is deprecated')
    return this.searchPartnerUsers(filters, additional)
  },
  getContactsByUserId (userId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/contact?user_id=' + userId).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  deleteContact (contactId, data = []) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/user/contact/' + contactId, {data: data}).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  createContact (contact) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/contact', contact).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  updateNotification (userId, notificationId, status) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/' + userId + '/notifications', {
        'notification_id': notificationId,
        'email_status': status
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  getNotifications (userId, data) {
    let str = ''
    if (data !== undefined) {
      str = Object.keys(data).map(function (key) {
        return key + '=' + data[key]
      }).join('&')
    }
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/' + userId + '/notifications?' + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  updateImage (userId, blob) {
    let fd = new FormData()
    if (blob) {
      fd.append('image', new File([blob], 'image.jpg', {type: 'image/jpeg'}))
    } else {
      fd.append('image', null)
    }
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/' + userId + '/image',
        mimeType: 'multipart/form-data',
        data: fd
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  resetPassword (email) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/reset-password',
        data: {email: email}
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  downgrade (userId) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/' + userId + '/downgrade',
        data: {user_id: userId}
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  confirmResetPassword (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/reset-password/confirm',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  updateAccount (userId, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/' + userId,
        // mimeType: 'multipart/form-data',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  upgrade (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/upgrade',
        // mimeType: 'multipart/form-data',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  createTaxDetails (userId, data) {
    return new Promise((resolve, reject) => {
      data.user_id = userId
      axios.post(config.server + '/user/addTaxDetails', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  removeTaxDetails (infoId, data) {
    let str = ''
    if (data !== undefined) {
      str = Object.keys(data).map(function (key) {
        return key + '=' + data[key]
      }).join('&')
    }
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/user/removeTaxDetails/' + infoId + '?' + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  updateProfile (userId, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/' + userId + '/profile',
        mimeType: 'multipart/form-data',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  getProfile (userId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/' + userId + '/profile').then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  createEmployee (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/employee', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  createPremium (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/premium', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  createPersonal (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/personal', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  createBusiness (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/business', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  updateBusiness (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/update-business', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  create (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  importCsvData (formData) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/import-employee-csv', formData, {
        headers: { 'content-type': 'multipart/form-data' }}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  saveEmployeeCsv (formData) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/save-employee-csv', formData, {
        headers: { 'content-type': 'multipart/form-data' }}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deActivate (userId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/' + userId + '/deactivate').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  activate (userId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/' + userId + '/activate').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  blockUser (userId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/' + userId + '/block').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  unblockUser (userId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/' + userId + '/unblock').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteUser (userId) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/user/' + userId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  logout (token) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/oauth/token').then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  login (credentials) {
    return new Promise((resolve, reject) => {
      credentials.client_id = config.client_id
      credentials.client_secret = config.client_secret
      credentials.grant_type = config.grant_type
      axios.post(config.server + '/oauth/token', credentials).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCurrentUser () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/current').then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  saveUserLogin (username) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/user-login?username=' + username).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserLoginDetails (userid) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/get-userlogin-details?userid=' + userid).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getAllBeneficiaries () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/get-all-beneficiaries').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getWcUsersCountries () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/get-wc-countries').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getWcUsersFromCountry (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/get-wcuser-from-country', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateBannerImage (userId, blob) {
    let fd = new FormData()
    if (blob) {
      fd.append('image', new File([blob], 'image.jpg', {type: 'image/jpeg'}))
    } else {
      fd.append('image', '')
    }
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/' + userId + '/banner-image',
        mimeType: 'multipart/form-data',
        data: fd
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  updateOrgImage (userId, blob) {
    let fd = new FormData()
    if (blob) {
      fd.append('image', new File([blob], 'image.jpg', {type: 'image/jpeg'}))
    } else {
      fd.append('image', '')
    }
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/' + userId + '/org-image',
        mimeType: 'multipart/form-data',
        data: fd
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  updateCard (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/update-card', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  addGivingCard (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/giving/add-giving-card/' + data.token, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  addGivingCardNew (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/giving/add-giving-card-new/' + data.payment_method_id, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  searchData (params, additional) {
    params = typeof params === 'object' && params !== null ? params : {}
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/user/user-search?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  validateFogotPwLink (code) { // Forgot password link validate
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/validate-forgot-link?code=' + code).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getAutomateUsers () {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/automate').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendEmailToPartner (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/send-email-to-partner', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateOrgStoryMedia (userId, storyMedia) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/' + userId + '/org-story',
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(storyMedia)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  removeOrgStoryMedia (data) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/user/org-story', {data: data}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPartnerTotalImpacts (partnerId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/getPartnerTotalImpacts', partnerId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getWCTotalImpacts (partnerId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/getWCTotalImpacts', partnerId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserCardsById () {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/cards').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserCardsListById () {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/cards-list').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteGivingCard (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/giving/delete-card', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  setPrimaryGivingCard (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/giving/card/set-primary', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserEncryptedId () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/get-encrypted-id').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserSubscriptionSetting () {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/contribution/subscription/setting').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserIndustryTemplateSuggestions () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/industry/templates').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendSegment (mediaName) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/send-media', mediaName).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserGivingCards (params = {}) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/giving/cards', params).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  setSegmentImpactHistoryData (userid) {
    let URL = config.server + '/user/setImpactHistorySegment'
    return new Promise((resolve, reject) => {
      axios.post(URL, {
        userid: userid
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  setSegmentPageDetails (userId, pageTitle, currentUrl = null, previousUrl = null) {
    let URL = config.server + '/user/setSegmentPageDetails'
    return new Promise((resolve, reject) => {
      axios.post(URL, {
        user_id: userId,
        page_title: pageTitle,
        current_url: currentUrl,
        previous_url: previousUrl
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  setSegmentDetails (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/send-segment', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendResetPasswordEmail (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/send-reset-email', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  geHelpScot () {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
      axios.post(config.server + '/user/getScotData').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCompnayOwner () {
    let url = config.server + '/user/getCompnayOwner'
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updatePartnership (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/updatePartnership', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPartneshipDetails (userId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/updatePartnership?user_id=' + userId).then((response) => {
        resolve(response.data)
      }, (error) => {
        // reject({error: error.body.error, status: error.status})
        reject(error)
      })
    })
  },
  getBoradcastNotifications (params) {
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/user/get-broadcast-notification?' + stringParams
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getBoradcastNotificationCount (params) {
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/user/get-broadcast-notification-count?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  readNotification (id) {
    let url = config.server + '/user/read-broadcast-notification'
    return new Promise((resolve, reject) => {
      axios.post(url, id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteNotification (id) {
    let url = config.server + '/user/delete-broadcast-notification'
    return new Promise((resolve, reject) => {
      axios.post(url, id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updatePaymentCard (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/update-payment-card', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  setPrimaryGivingCardNew (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/giving/card/set-primary-new', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteGivingCardNew (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/giving/delete-card-new', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  addAnnualDetails (userId, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/' + userId + '/annual-document',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteDocument (id) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/user/delete-document/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  addRemittancePDF (userId, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/' + userId + '/remittance-pdf',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateRemittancePDFStatus (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user' + '/update-remittance-pdf-status',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getAnnualDocument (userId) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'GET',
        url: config.server + '/user/' + userId + '/get-annual-document'
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getRemittancePDF (params, user = null) {
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = ''
    url = config.server + '/user/get-remittance-pdf?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteRemittancePDF (id) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/user/delete-remittance-pdf/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  downloadRemittancePDF (fileName) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'GET',
        url: config.server + '/user/download-remittance-pdf/' + fileName,
        responseType: 'blob'
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getWorthyCauseName (userId) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'GET',
        url: config.server + '/user/get-wc-name/' + userId
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  addACTag () {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/add-ac-tag'
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  verifyOtp (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/verify-otp',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendOtp (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/send-otp',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  resendOtp (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/resend-otp',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  checkEmailVerified (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/check-email-is-verified',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  verifyEmail (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/verify-email',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  verify2fa (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/verify-2fa',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateFlagEmailVerf (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/update-verify-email-flag',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default userAPI



// WEBPACK FOOTER //
// ./src/api/user.js